export const REQUIRED_QUERY_PARAMS = [
  'response_type',
  'client_id',
  'redirect_uri',
  'scope',
];
